import React from 'react';
import classNames from 'classnames';
import { Bubble } from '@lt/components';
import QuestionCircle from '@lt/components/icons-react/QuestionCircle';
import type { LabelVariant } from '../../types';

import styles from './hotelCardLabel.module.css';

type HotelCardLabelProps = {
  labelText: string;
  Icon?: React.ReactNode;
  tooltipText?: string;
  variant: LabelVariant;
};

const HotelCardLabel = (props: HotelCardLabelProps) => {
  const { labelText, Icon, tooltipText, variant } = props;

  return (
    <Bubble
      className={styles.styledBubble}
      disabled={!tooltipText}
      text={tooltipText}
    >
      <div className={classNames(styles.label, styles[variant])}>
        {Icon && <div className={styles.iconWrapper}>{Icon}</div>}
        <div className={styles.textWrapper}>{labelText}</div>
        {tooltipText ? (
          <QuestionCircle
            className={classNames(
              styles.tooltip,
              styles[
                `tooltip${variant.charAt(0).toUpperCase() + variant.slice(1)}`
              ],
            )}
          />
        ) : null}
      </div>
    </Bubble>
  );
};

export default HotelCardLabel;
